<template lang="html">
  <boxwrap class="user--inner">
    <toolbar>
      <toolbar-items class="-searchbar">
        <search
          class="search-bar-wrap"
          :dateBy="dateBy"
          :filterBy="filterBy"
          @trigger="trigger"
          @refresh="search"
          @clear="search"
        >
        </search>

        <button
          class="btn--create"
          title="add user"
          @click="createPopup()"
        >
          <i class="ico--create"></i>
        </button>

        <button
          class="btn--delete"
          title="delete"
          v-if="selected.length > 0"
          @click="deleteData()"
        >
          <i class="ico--delete"></i>
        </button>

        <button
          class="btn--restore"
          title="restore"
          v-if="selected.length > 0"
          @click="restore()"
        >
          <i class="ico--restore"></i>
        </button>

        <button
          class="btn--modify"
          title="save"
          @click="update()"
          v-if="selected.length > 0"
        >
          <i class="ico--save"></i>
        </button>

        <button
          class="btn--message"
          title="message"
          @click="messageUser()"
        >
          <i class="ico--message"></i>
        </button>

        <button
          class="btn--update"
          @click="changeAgent()"
          v-if="selected.length > 0"
        >
          <i class="ico--changeagent"></i>
        </button>

        <button
          class="btn--modify"
          v-if="selected.length > 0"
          @click="updateStatus('C')"
        >
          <span>confirm</span>
        </button>

        <button
          class="btn--delete"
          v-if="selected.length > 0"
          @click="updateStatus('R')"
        >
          <span>reject</span>
        </button>

        <div class="toolbar-rightbtns">
          <button
            class="btn--import-csv"
          >
            <i class="ico--import"></i>
          </button>
          <button
            class="btn--export-csv"
          >
            <i class="ico--export"></i>
          </button>
          <button
            class="btn--tbl-settings"
            @click="showTblSettings = true"
          >
            <i class="ico--settings"></i>
          </button>
        </div>

      </toolbar-items>
    </toolbar>

    <boxwrap-contents :class="{'data-loading': showDataLoading}">
      <check-data-list
        label="loading"
        v-if="isDataLoading || isEmpty"
        :isLoading="isDataLoading"
        :isEmpty="isEmpty"
      >
      </check-data-list>
      <tbl
        :scrollable="true"
        :dataLoading="isDataLoading"
        v-else
      >
        <tbl-inner v-if="!isDataLoading">
          <tbl-head>
            <tbl-row>
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    @click="checkAll(users)"
                    :checked="selectAll"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                :sort="true"
                v-if="checkCol('id', tblSetting)"
                @click.native="sort('id')"
              >
                no
              </tbl-td>

              <tbl-td
                name="login-id"
                :sort="true"
                v-if="checkCol('login_id', tblSetting)"
                @click.native="sort('login_id')"
              >
                login id
              </tbl-td>

              <tbl-td
                :sort="true"
                name="login-name"
                v-if="checkCol('login_name', tblSetting)"
                @click.native="sort('login_name')"
              >
                login name
              </tbl-td>

              <tbl-td
                :sort="true"
                name="level"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('level', tblSetting)"
                @click.native="sort('level_id')"
              >
                level
              </tbl-td>

              <tbl-td
                :sort="true"
                name="agent"
                v-if="checkCol('agent', tblSetting)"
                @click.native="sort('agent')"
              >
                agent
              </tbl-td>

              <tbl-td
                :sort="true"
                name="email"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('email', tblSetting)"
                @click.native="sort('login_name')"
              >
                email
              </tbl-td>

              <tbl-td
                :sort="true"
                name="phone"
                v-if="checkCol('phone', tblSetting)"
                @click.native="sort('phone')"
              >
                phone
              </tbl-td>

              <tbl-td
                :sort="true"
                name="vip"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('vip', tblSetting)"
                @click.native="sort('vip_id')"
              >
                vip
              </tbl-td>

              <tbl-td
                :sort="true"
                name="status"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') &&  checkCol('status', tblSetting)"
                @click.native="sort('status')"
              >
                status
              </tbl-td>

              <tbl-td
                name="bank-name"
                :sort="true"
                v-if="checkCol('bank_name', tblSetting)"
                @click.native="sort('bank_name')"
              >
                bank name
              </tbl-td>

              <tbl-td
                name="bank-account-name"
                :sort="true"
                v-if="checkCol('bank_account_name', tblSetting)"
                @click.native="sort('bank_account_name')"
              >
                bank account name
              </tbl-td>

              <tbl-td
                name="bank-numbers"
                :sort="true"
                v-if="checkCol('bank_account_number', tblSetting)"
                @click.native="sort('bank_account_number')"
              >
                bank number
              </tbl-td>

              <tbl-td
                name="referrer"
                v-if="checkCol('referrer', tblSetting)"
              >
                referrer
              </tbl-td>

              <tbl-td
                :sort="true"
                name="code"
                v-if="checkCol('code', tblSetting)"
                @click.native="sort('code')"
              >
                code
              </tbl-td>

              <tbl-td
                name="deposit-account"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('bank_account_name', tblSetting)"
              >
                deposit account

                <ul class="tbl-subcells col2">
                  <li :sort="true" @click="sort('deposit_account_name')"  class="bank-account-name">
                    <span>account name</span>
                  </li>
                  <li :sort="true" @click="sort('deposit_account_number')" class="bank-number">
                    <span>account number</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                :sort="true"
                name="balance"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('amount', tblSetting)"
                @click.native="sort('amount')"
              >
                balance
              </tbl-td>

              <tbl-td
                name="points"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('point', tblSetting)"
              >
                points
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-cash-in"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_cash_in', tblSetting)"
                @click.native="sort('total_cash_in')"
              >
                total cash in
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-cash-out"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_cash_out', tblSetting)"
                @click.native="sort('total_cash_out')"
              >
                total cash out
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-cash-net"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_cash_net', tblSetting)"
                @click.native="sort('total_cash_net')"
              >
                total cash net
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-bet-sports"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_sports', tblSetting)"
                @click.native="sort('total_bet_sports')"
              >
                total bet sports
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-bet-virtual"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_virtual', tblSetting)"
                @click.native="sort('total_bet_virtual')"
              >
                total bet virtual
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-bet-mini"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_mini', tblSetting)"
                @click.native="sort('total_bet_mini')"
              >
                total bet mini
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-bet-slot"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_slot', tblSetting)"
                @click.native="sort('total_bet_slot')"
              >
                total bet slot
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-bet"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet', tblSetting)"
                @click.native="sort('total_bet')"
              >
                total bet
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-win-sports"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_sports', tblSetting)"
                @click.native="sort('total_win_sports')"
              >
                total win-sports
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-win-virtual"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_virtual', tblSetting)"
                @click.native="sort('total_win_virtual')"
              >
                total win-virtual
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-win-mini"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_mini', tblSetting)"
                @click.native="sort('total_win_mini')"
              >
                total win-mini
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-win-slot"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_slot', tblSetting)"
                @click.native="sort('total_win_slot')"
              >
                total win-slot
              </tbl-td>

              <tbl-td
                :sort="true"
                name="total-win"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win', tblSetting)"
                @click.native="sort('total_win')"
              >
                total win
              </tbl-td>

              <tbl-td
                :sort="true"
                name="created-at"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('created_at', tblSetting)"
                @click.native="sort('created_at')"
              >
                created at
              </tbl-td>

              <tbl-td
                :sort="true"
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
                @click.native="sort('updated_at')"
              >
                updated at
              </tbl-td>

              <tbl-td
                :sort="true"
                name="deleted-at"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('deleted_at', tblSetting)"
                @click.native="sort('deleted_at')"
              >
                deleted at
              </tbl-td>

              <tbl-td
                name="memo"
                v-if="(getRouteStatus === 'pending' || getRouteStatus === 'waiting') && checkCol('deleted_at', tblSetting)"
              >
                memo
              </tbl-td>

              <tbl-td
                name="confirm-reject"
                v-if="(getRouteStatus === 'pending' || getRouteStatus === 'waiting') && checkCol('deleted_at', tblSetting)"
              ></tbl-td>
            </tbl-row>
          </tbl-head>

          <tbl-body>
            <tbl-row
              v-for="(user, x) in users"
              :key="x"
              :class="{'is-deleted': user.deleted_at}"
            >
              <tbl-td name="checkbox">
                <checkbox>
                  <input
                    type="checkbox"
                    v-model="selected"
                    :value="user.id"
                  />
                </checkbox>
              </tbl-td>

              <tbl-td
                name="no"
                v-if="checkCol('id', tblSetting)"
              >
                {{ generateNumber(x, params.page, params.rows, params.sort, uCount || 0) }}
              </tbl-td>

              <tbl-td
                name="login-id"
                @click.native="openUser(user.id, 'info/undeleted')"
                v-if="checkCol('login_id', tblSetting)"
              >
                {{ user.login_id }}
              </tbl-td>

              <tbl-td
                name="login-name"
                @click.native="openUser(user.id, 'bet-history/all')"
                v-if="checkCol('login_name', tblSetting)"
              >
                {{ user.login_name }}
              </tbl-td>

              <tbl-td
                name="level"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('level', tblSetting)"
              >
                <select-list
                  :title="user.level.name"
                  :withReset="true"
                  v-model="user.level_id"
                  v-if="checkPermission"
                  @reset="resetTrigger(user)"
                >
                  <select-option
                    v-for="level in levels"
                    :key="level.id"
                    :value="level.id"
                    :name="level.name"
                    @click.native="setSelected(user)"
                  >
                    {{ level.name }}
                  </select-option>
                </select-list>

                <span v-else>{{ user.level.name }}</span>
              </tbl-td>

              <tbl-td
                name="agent"
                v-if="checkCol('agent', tblSetting)"
              >
                {{ user.code.agent_id }}
              </tbl-td>

              <tbl-td
                name="email"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('email', tblSetting)"
              >
                {{ user.email }}
              </tbl-td>

              <tbl-td
                name="phone"
                v-if="checkCol('phone', tblSetting)"
              >
                {{ user.phone }}
              </tbl-td>

              <tbl-td
                name="vip"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('vip', tblSetting)"
              >
                <select-list
                  :title="user.vip.name"
                  :withReset="true"
                  v-model="user.vip_id"
                  v-if="checkPermission"
                  @reset="resetTrigger(user)"
                >
                  <select-option
                    v-for="vip in vipList"
                    :value="vip.id"
                    :key="vip.id"
                    :name="vip.name"
                    @click.native="setSelected(user)"
                  >
                    {{ vip.name }}
                  </select-option>
                </select-list>
                <span v-else>{{ user.vip.name }}</span>
              </tbl-td>

              <tbl-td
                name="status"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('status', tblSetting)"
              >
                <select-list
                  :title="user.status | status"
                  :withReset="true"
                  v-model="user.status"
                  v-if="!user.deleted_at && checkPermission"
                  @reset="resetTrigger(user)"
                >
                  <select-option
                    v-for="(stat, x) in userStatus[user.id]"
                    :key="x"
                    :value="stat"
                    :name="stat | status"
                    @click.native="setSelected(user)"
                  >
                    {{ stat | status }}
                  </select-option>
                </select-list>
                <span v-else> {{ (!user.deleted_at ? user.status : 'd') | status }}</span>
              </tbl-td>

              <tbl-td
                name="bank-name"
                v-if="checkCol('bank_account_name', tblSetting)"
              >
                <ul
                  class="tbl-subcells col3"
                  v-for="(wallet, i) in user.wallets"
                  v-if="wallet.is_main"
                  :key="i"
                >
                  <li class="bank-name">
                    <span>{{ wallet.bank_name }}</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                name="bank-account-name"
                v-if="checkCol('bank_name', tblSetting)"
              >
                <ul
                  class="tbl-subcells col3"
                  v-for="(wallet, i) in user.wallets"
                  v-if="wallet.is_main"
                  :key="i"
                >
                  <li class="bank-account-name">
                    <span>{{ wallet.bank_account_name }}</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                name="bank-numbers"
                v-if="checkCol('bank_account_number', tblSetting)"
              >
                <ul
                  class="tbl-subcells col3"
                  v-for="(wallet, i) in user.wallets"
                  v-if="wallet.is_main"
                  :key="i"
                >
                  <li class="bank-number">
                    <span>{{ wallet.bank_number }}</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                name="referrer"
                @click.native="openUser(user.referrer.id, 'info')"
                v-if="checkCol('referrer', tblSetting)"
              >
                <template v-if="user.referrer">
                  {{ user.referrer.login_name }}
                </template>

                <template v-if="!user.referrer">-</template>
              </tbl-td>

              <tbl-td
                name="code"
                v-if="checkCol('code', tblSetting)"
              >
                {{ user.code.code }}
              </tbl-td>

              <tbl-td
                name="deposit-account"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('bank_account_name', tblSetting)"
              >
                <ul class="tbl-subcells col2">
                  <li class="bank-account-name">
                    <span>{{ user.code.bank_account_name }}</span>
                  </li>

                  <li class="bank-number">
                    <span>{{ user.code.bank_number }}</span>
                  </li>
                </ul>
              </tbl-td>

              <tbl-td
                name="balance"
                class="is-amount"
                @click.native="openUser(user.id, 'cash-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('amount', tblSetting)"
              >
                {{ user.amount | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="points"
                class="is-amount"
                @click.native="openUser(user.id, 'point-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('point', tblSetting)"
              >
                {{ user.point | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-cash-in"
                class="is-amount"
                @click.native="openUser(user.id, 'cash-history/cash-in')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_cash_in', tblSetting)"
              >
                {{ user.total_cash_in | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-cash-out"
                class="is-amount"
                @click.native="openUser(user.id, 'cash-history/cash-out')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_cash_out', tblSetting)"
              >
                {{ user.total_cash_out | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-cash-net"
                class="is-amount"
                @click.native="openUser(user.id, 'cash-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_cash_net', tblSetting)"
              >
                {{ user.total_cash_in | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-bet-sports"
                class="is-amount"
                @click.native="openUser(user.id, 'bet-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_sports', tblSetting)"
              >
                {{ user.total_bet_sports | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-bet-virtual"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_virtual', tblSetting)"
              >
                {{ user.total_bet_virtual | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-bet-mini"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_mini', tblSetting)"
              >
                {{ user.total_bet_mini | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-bet-slot"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet_slot', tblSetting)"
              >
                {{ user.total_bet_slot | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-bet"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_bet', tblSetting)"
              >
                {{ user.total_bet | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-win-sports"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_sports', tblSetting)"
              >
                {{ user.total_win_sports | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-win-virtual"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_virtual', tblSetting)"
              >
                {{ user.total_win_virtual | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-win-mini"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_mini', tblSetting)"
              >
                {{ user.total_win_mini | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-win-slot"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win_slot', tblSetting)"
              >
                {{ user.total_win_slot | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="total-win"
                class="is-amount"
                @click.native="openUser(user.id, 'transaction-history/all')"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('total_win', tblSetting)"
              >
                {{ user.total_win | FormatAmount }}
              </tbl-td>

              <tbl-td
                name="created-at"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('created_at', tblSetting)"
              >
                {{ user.created_at | date }}
              </tbl-td>

              <tbl-td
                name="updated-at"
                v-if="checkCol('updated_at', tblSetting)"
              >
                {{ user.updated_at | date }}
              </tbl-td>

              <tbl-td
                name="deleted-at"
                v-if="(getRouteStatus !== 'pending' && getRouteStatus !== 'waiting') && checkCol('deleted_at', tblSetting)"
              >
                {{ user.deleted_at | date }}
              </tbl-td>

              <tbl-td
                name="memo"
                v-if="(getRouteStatus === 'pending' || getRouteStatus === 'waiting') && checkCol('deleted_at', tblSetting)"
              >
                <div class="input-wrap">
                  <input type="text" v-model="user.memo"/>
                </div>
              </tbl-td>

              <tbl-td
                name="confirm-reject"
                v-if="(getRouteStatus === 'pending' || getRouteStatus === 'waiting') && checkCol('deleted_at', tblSetting)"
              >
                <button
                  class="btn--restore"
                  @click="selected.push(user.id), user.status = 'C', update()"
                >
                  Confirm
                </button>

                <button
                  class="btn--create"
                  @click="selected.push(user.id), user.status = 'W', update()"
                >
                  Waiting
                </button>

                <button
                  class="btn--delete"
                  @click="selected.push(user.id), user.status = 'R', update()"
                >
                  Reject
                </button>
              </tbl-td>
            </tbl-row>
          </tbl-body>
        </tbl-inner>

        <tbl-footer>
          <pagination
            :total="uCount"
            v-model="params.page"
            :rows="params.rows"
            @page="trigger"
          >
          </pagination>
        </tbl-footer>
      </tbl>
    </boxwrap-contents>

    <modal
      class="modal--create-user"
      title="create user"
      v-if="showCreate"
      :activate="showCreate"
      @activate="showCreate = $event"
    >
      <template slot="body">
        <div class="form-head">
          <div class="form-lbl"><span>user count</span></div>
          <div class="form-data">
            <div class="input-wrap">
              <input v-model.number="count" />
            </div>
          </div>
        </div>

        <div
          class="form-con"
          v-for="(user, x) in manualUsers"
          :key="x"
        >
          <div class="form-items">
            <div class="form-lbl"><span>login id sdf</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'login_id')}"
              >
                <input placeholder="login id" v-model="user.login_id"/>
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>login name</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'login_name')}"
              >
                <input placeholder="login name" v-model="user.login_name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>password</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'password')}"
              >
                <input placeholder="password" v-model="user.password" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>email</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'email')}"
              >
                <input placeholder="email" v-model="user.email" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>phone</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'phone')}"
              >
                <input placeholder="phone" v-model="user.phone" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank account name</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_account_name')}"
              >
                <input placeholder="bank account name" v-model="user.bank_account_name" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank number</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_number')}"
              >
                <input placeholder="bank number" v-model="user.bank_number" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank password</span></div>
            <div class="form-data">
              <div
                class="input-wrap"
                :class="{'error': checkValidation(x, 'bank_password')}"
              >
                <input placeholder="bank password" v-model="user.bank_password" />
              </div>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>bank name</span></div>
            <div class="form-data">
              <select-list
                :title="banks[0].name"
                :withReset="true"
                v-model="user.bank_id"
              >
                <select-option
                  :value="bank.id"
                  :name="bank.id"
                  v-for="(bank, e) in banks"
                  :key="e"
                >
                  {{ bank.name }}
                </select-option>
              </select-list>
            </div>
          </div>

          <div class="form-items">
            <div class="form-lbl"><span>currency</span></div>
            <div class="form-data">
              <select-list
                :title="'USD'"
                :withReset="true"
                v-model="user.currency_id"
              >
                <select-option
                  value="1"
                  name="USD"
                >
                  USD
                </select-option>
                <select-option
                  value="2"
                  name="JPY"
                >
                  JPY
                </select-option>
                <select-option
                  value="2"
                  name="KRW"
                >
                  KRW
                </select-option>
              </select-list>
            </div>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--confirm -withlabel"
          @click="create()"
        >
          <i class="ico--create"></i>
          <span>create</span>
        </button>
      </template>
    </modal>

    <modal
      class="modal--change-agent"
      title="change user agent"
      v-if="showChangeAgent"
      :activate="showChangeAgent"
      @activate="showChangeAgent = $event"
    >

      <template slot="body">
        <div class="change-agent-con">
          <div class="change-agent">
            <div class="change-agent-lbl">
              <span>Apply to all</span>
            </div>
            <select-list
              title="Select agent"
              :withReset="true"
              v-model="agent"
            >
              <select-option
                :value="agent.login_id"
                :name="agent.login_name"
                v-for="(agent, i) in agentList"
                :key="i"
              >
                {{ agent.login_id }}
              </select-option>
            </select-list>

          </div>

          <div class="change-agent-table">
            <tbl>
              <tbl-inner>
                <tbl-head>
                  <tbl-row>
                    <tbl-td name="login-id">
                      Login ID
                    </tbl-td>

                    <tbl-td name="login-name">
                      Login Name
                    </tbl-td>

                    <tbl-td name="from-agent">
                      From Agent
                    </tbl-td>

                    <tbl-td name="to-agent">
                      To Agent
                    </tbl-td>
                  </tbl-row>
                </tbl-head>

                <tbl-body>
                  <tbl-row
                    v-for="(user, i) in selectedUsers"
                    :key="user.id"
                  >
                    <tbl-td name="login-id">
                      {{ user.login_id }}
                    </tbl-td>

                    <tbl-td name="login-name">
                      {{ user.login_name }}
                    </tbl-td>

                    <tbl-td name="from-agent">
                      {{ user.code.agent_id }}
                    </tbl-td>
                    <tbl-td name="to-agent">
                      <!-- <select v-model="agents[i].agent_id" placeholder="select agent">
                        <option :selected="true" v-for="agent in agentCodes">{{agent.login_id}}</option>
                      </select> -->
                      <select-list
                        title="Select agent"
                        :withReset="true"
                        v-model="agents[i].agent_id"
                      >
                        <select-option
                          :value="agent.id"
                          :name="agent.login_id"
                          :key="agent.id"
                          v-for="agent in agentList"
                        >
                          {{ agent.login_id }}
                        </select-option>
                      </select-list>
                    </tbl-td>
                  </tbl-row>
                </tbl-body>
              </tbl-inner>
            </tbl>
          </div>
        </div>
      </template>

      <template slot="footer">
        <button
          class="btn--modify -withlabel"
          @click="updateAgent()"
        >
          <i class="ico--save"></i>
          <span>modify</span>
        </button>
      </template>
    </modal>

    <message
      :selectedUsers="selectedUsers"
      :showMessageUser="showMessageUser"
      @closeComponent="showMessageUser = $event"
    >
    </message>

    <table-settings
      :showTblSettings="showTblSettings"
      :allCols="allCols"
      :tblSetting="tblSetting"
      :activate="showTblSettings"
      v-if="modConfig.tableConfig"
      @activate="showTblSettings = $event"
      @load="showLoad()"
    >
    </table-settings>
  </boxwrap>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

import { user } from '@/socket'

//= components
import Checkbox from '@/components/base/Checkbox'
import Pagination from '@/components/base/Pagination'
import Modal from '@/components/base/Modal'
import Search from '@/components/base/search/Search'
import CheckDataList from '@/components/base/CheckDataList'
import TextArea from '@/components/base/TextArea'
import Message from '@/components/common/message/Message'

import '@/components/base/input/InputSuggestion'
import '@/components/base/table/Table'
import '@/components/base/select/Select'
import '@/components/common/table-settings/TableSettings'

//= filters
import FormatAmount from '@/assets/js/filters/FormatAmount'

//= mixin
import { swal } from '@/assets/js/mixins/base/Swal'
import { checkAll } from '@/assets/js/mixins/base/CheckAll'

export default {
  name: 'users',

  components: {
    Pagination,
    Checkbox,
    Modal,
    Search,
    CheckDataList,
    TextArea,
    Message
  },

  filters: {
    FormatAmount,

    status (stat) {
      let status = ''
      switch (stat.toLowerCase()) {
        case 'c':
          status = 'confirmed'
          break
        case 'r':
          status = 'rejected'
          break
        case 'w':
          status = 'waiting'
          break
        case 'p':
          status = 'pending'
          break
        case 'b':
          status = 'ban'
          break
        case 'd':
          status = 'deleted'
          break
      }
      return status
    }
  },

  mixins: [ swal, checkAll ],

  data () {
    let params = Object.assign(
      {
        rows: 50,
        page: 1,
        filter_by: '',
        q: '',
        sort_by: 'id',
        sort: 'desc',
        date_from: '',
        date_to: ''
      },
      this.$route.query
    )

    return {
      params,

      status: 'all',

      showCreate: false,
      showTblSettings: false,
      showChangeAgent: false,
      showMessageUser: false,

      count: 1,

      manualUsers: [],
      selected: [],
      selectAll: false,
      selectedUsers: [],

      isDataLoading: true,
      isEmpty: false,
      showDataLoading: false,

      users: [],

      filterBy: [
        {
          value: 'id',
          display: 'user id'
        },

        {
          value: 'login_id',
          display: 'user name'
        },

        {
          value: 'email',
          display: 'email'
        },

        {
          value: 'referral_id',
          display: 'referrer'
        },

        {
          value: 'agent',
          display: 'agent name'
        },

        {
          value: 'code',
          display: 'code'
        },

        {
          value: 'phone',
          display: 'phone'
        },

        {
          value: 'amount',
          display: 'balance'
        },

        {
          value: 'bank_account_number',
          display: 'bank account number'
        },

        {
          value: 'bank_account_name',
          display: 'bank account name'
        }
      ],

      dateBy: [
        {
          value: 'created_at',
          display: 'created at'
        },

        {
          value: 'updated_at',
          display: 'updated at'
        },

        {
          value: 'deleted_at',
          display: 'deleted at'
        }
      ],

      tblSetting: 'user_list',
      allCols: [
        {
          display: 'no',
          value: 'id'
        },
        {
          display: 'login id',
          value: 'login_id'
        },
        {
          display: 'login name',
          value: 'login_name'
        },
        {
          display: 'level',
          value: 'level'
        },
        {
          display: 'agent',
          value: 'agent'
        },
        {
          display: 'email',
          value: 'email'
        },
        {
          display: 'phone',
          value: 'phone'
        },
        {
          display: 'vip',
          value: 'vip'
        },
        {
          display: 'status',
          value: 'status'
        },
        {
          display: 'wallets',
          value: 'wallets'
        },
        {
          display: 'referrer',
          value: 'referrer'
        },
        {
          display: 'code',
          value: 'code'
        },
        {
          display: 'bank account name',
          value: 'bank_account_name'
        },
        {
          display: 'bank name',
          value: 'bank_name'
        },
        {
          display: 'bank account number',
          value: 'bank_account_number'
        },
        {
          display: 'amount',
          value: 'amount'
        },
        {
          display: 'point',
          value: 'point'
        },
        {
          display: 'total cash in ',
          value: 'total_cash_in'
        },
        {
          display: 'total cash out ',
          value: 'total_cash_out'
        },
        {
          display: 'total cash net ',
          value: 'total_cash_net'
        },
        {
          display: 'total bet virtual ',
          value: 'total_bet_virtual'
        },
        {
          display: 'total bet mini ',
          value: 'total_bet_mini'
        },
        {
          display: 'total bet slot ',
          value: 'total_bet_slot'
        },
        {
          display: 'total bet bet ',
          value: 'total_bet'
        },
        {
          display: 'total bet sports ',
          value: 'total_win_sports'
        },
        {
          display: 'total bet virtual ',
          value: 'total_win_virtual'
        },
        {
          display: 'total bet mini ',
          value: 'total_win_mini'
        },
        {
          display: 'total win slot ',
          value: 'total_win_slot'
        },
        {
          display: 'total win ',
          value: 'total_win'
        },
        {
          display: 'created at ',
          value: 'created_at'
        },
        {
          display: 'updated at ',
          value: 'updated_at'
        },
        {
          display: 'deleted at ',
          value: 'deleted_at'
        }
      ],
      agent: null,
      agents: [],

      validation: []
    }
  },

  computed: {
    ...mapState('user', { allUsers: 'users', uCount: 'count' }),
    ...mapState('bank', [ 'banks' ]),
    ...mapState('vip', [ 'vipList' ]),
    ...mapState('level', [ 'levels' ]),
    ...mapState('code', { allCodes: 'codes' }),
    ...mapState('agent', { agentList: 'agents' }),
    ...mapState('deposit-account', [ 'depositAccounts' ]),

    getRouteStatus () {
      return this.$route.params.status
    },

    checkPermission () {
      let permission = JSON.parse(window.localStorage.permission)
      let dbKey = this.$route.meta.dbKey
      let obj

      for (let key in permission) {
        if (dbKey === key) {
          obj = permission[key]
        }
      }

      return obj === 'rw' ? 1 : ''
    },

    userStatus () {
      let status = {}

      this.users.forEach((e) => {
        switch (e.status.toLowerCase()) {
          case 'c':
            status[e.id] = ['B']
            break
          case 'w':
          case 'p':
            status[e.id] = ['C', 'R', 'W']
            break
          case 'b':
            status[e.id] = ['C']
            break
          case 'r':
            status[e.id] = ['P', 'W']
            break
        }
      })

      return status
    }
  },

  watch: {
    '$route' (to, from) {
      if (!this.showDataLoading) {
        this.showDataLoading = true
      }
      if (to.params.status !== from.params.status) {
        this.showDataLoading = false
      }
      this.search(this.generate(to.query))
    },

    count () {
      this.createPopup()
    },

    selected () {
      this.selectedUsers = this.users.filter((e) => {
        return this.selected.indexOf(e.id) > -1
      })
    }
  },

  created () {
    if (this.$route.params.status === undefined) {
      this.$router.push(`${this.$route.path}/all`)
    }
    this.params = this.generate(this.params)
    this.search()

    this.getBanks({ status: 'active' })
    this.getVips()
    this.getLevels()
    this.getAccounts({ status: 'all' })
  },

  mounted () {
    user.on('register', (message) => {
      this.search(this.generate(this.params))
    })
  },

  methods: {
    ...mapActions('user', ['getCount', 'setAgent']),
    ...mapActions('user', {
      createUsers: 'create',
      patch: 'update',
      getUsers: 'get',
      deleteUsers: 'delete'
    }),

    ...mapActions('bank', { getBanks: 'get' }),
    ...mapActions('vip', { getVips: 'get' }),
    ...mapActions('level', { getLevels: 'get' }),
    ...mapActions('code', { getCodes: 'get', getCodeArchive: 'archive' }),
    ...mapActions('deposit-account', { getAccounts: 'get', getAccountArchive: 'archive' }),
    ...mapActions('agent', { getAgentArchive: 'archive' }),
    ...mapActions('meta', { getAllMeta: 'get' }),
    ...mapActions('admin-logs', { createLog: 'post' }),

    async trigger (query) {
      this.params = query || this.params
      this.$router.push({ query: this.params })
    }, // trigger

    async search (query) {
      this.params = query || this.params

      this.status = this.$route.params.status

      this.selected = []

      // == flags reset
      this.isEmpty = false
      if (!this.showDataLoading) {
        this.isDataLoading = true
      }

      await this.getUsers({
        status: this.status,
        params: this.params
      })

      await this.getCount({
        status: this.status,
        params: this.params
      })

      this.users = JSON.parse(JSON.stringify(this.allUsers))

      // == flags set
      this.isDataLoading = false
      this.showDataLoading = false
      if (!this.users.length) {
        this.isEmpty = true
      }
    }, // search

    async update () {
      let success = async () => {
        let keys = ['login_id', 'login_name', 'email', 'level_id', 'vip_id', 'status']
        let memo = ''

        this.showDataLoading = true

        let edited = this.users.filter((e) => {
          return this.selected.indexOf(e.id) > -1
        })

        for (var x = 0; x < edited.length; x++) {
          let data = {}

          for (var key in edited[x]) {
            if (keys.indexOf(key) > -1) {
              data[key] = edited[x][key]
            } // end if
          } // end for

          try {
            await this.patch({ data: data, id: edited[x].id })
            this.createLog({ action: 'updated', origin: 'users' })
            if (edited[x].memo) {
              await this.createMemo({ memo: edited[x].memo, id: edited[x].id })
              this.createLog({ action: 'insert', origin: 'users memo' })
            }
          } catch (err) {

          }
        } // end for

        this.selectAll = false
        this.showDataLoading = false
        this.search()
        this.getAllMeta()

        if (!this.users.length) {
          this.isEmpty = true
        }
      }

      this.$alert('prompt', 'Are you sure you want to modify the following user(s)?', {}, { success }, 'Modify User')
    },

    updateStatus (status) {
      this.users.forEach((e) => {
        if (this.selected.indexOf(e.id) > -1) {
          e.status = status
        }
      })

      this.update()
    },

    async sort (sortBy) {
      if (this.params.sort === 'asc') {
        this.params.sort = 'desc'
      } else {
        this.params.sort = 'asc'
      }

      this.params.sort_by = sortBy

      if (!this.showDataLoading) {
        this.showDataLoading = true
      }

      // this.search()
      this.$router.push({ query: this.params })
    },

    async deleteData () {
      let success = async () => {
        this.showDataLoading = true

        for (var x = 0; x < this.selected.length; x++) {
          await this.deleteUsers({ uid: this.selected[x] })
        }

        this.selectAll = false
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to delete the following user(s)?', {}, { success }, 'Delete User')
    },

    async restore () {
      let success = async () => {
        this.showDataLoading = true

        for (var x = 0; x < this.selected.length; x++) {
          await this.patch({
            id: this.selected[x],
            data: {
              deleted_at: null
            }
          })
        }

        this.selectAll = false
        this.search()
      }

      this.$alert('prompt', 'Are you sure you want to restore the following user(s)?', {}, { success }, 'Restore User')
    },

    async changeAgent () {
      this.selectedUsers.forEach((e) => {
        this.agents.push({
          user_id: e.id,
          agent_id: null
        })
      })

      await this.getAgentArchive()
      this.showChangeAgent = true
    },

    async updateAgent () {
      for (var x = 0; x < this.agents.length; x++) {
        await this.setAgent({
          user_id: this.agents[x].user_id,
          agent_id: this.agents[x].agent_id
        })
      }
      this.agents = []
      this.search()
      this.showChangeAgent = false
    },

    createPopup () {
      this.showCreate = true

      this.manualUsers = []
      for (var x = 0; x < this.count; x++) {
        this.manualUsers.push({
          login_id: '',
          login_name: '',
          email: '',
          phone: '',
          password: '',
          bank_account_name: '',
          bank_number: '',
          bank_password: '',
          bank_id: 1,
          currency_id: 1
        })
      }
    },

    checkValidation (val, key) {
      if (this.validation.length) {
        let filter = this.validation.filter((e) => {
          return parseInt(e.index) === parseInt(val)
        })

        let find = filter.find((e) => {
          return e.value === key
        })

        return !!find
      }
      return false
    },

    create () {
      let success = async () => {
        try {
          await this.createUsers(this.manualUsers)
          this.$alert('success', 'You have successfully created a new user.', {}, '', 'Success')

          this.createLog({ action: 'create', origin: 'users' })

          this.showCreate = false
          await this.getUsers({ status: this.status, params: this.params })
          this.users = JSON.parse(JSON.stringify(this.allUsers))
        } catch (err) {
          this.$alert('error', 'The user created already exists.', {}, '', 'Error')
        }
      }

      for (var x = 0; x < this.manualUsers.length; x++) {
        for (var key in this.manualUsers[x]) {
          if (this.manualUsers[x][key] === '') {
            this.validation.push({
              index: x,
              value: key
            })
          }
        }
      }

      if (this.validation.length) {
        alert('pls check ur  inputs')
        setTimeout(() => {
          this.validation = []
        }, 3000)
        return
      }

      this.$alert('prompt', 'Are you sure you want to continue?', {}, { success }, 'Create User')
    }, // create user

    setSelected (user) {
      this.$nextTick(() => {
        let result = this.allUsers.find((row) => {
          return row.id === user.id
        })

        let idx = this.selected.indexOf(user.id)

        if (user.level_id === result.level_id &&
            user.vip_id === result.vip_id &&
            user.status === result.status &&
            idx > -1) {
          this.selected.splice(idx, 1)
          return
        }

        if (user.level_id === result.level_id &&
          user.vip_id === result.vip_id &&
          user.status === result.status) {
          return
        }

        this.selected.push(user.id)
        this.selected = this.selected.filter((val, idx, arr) => {
          return arr.indexOf(val) === idx
        })
      })
    },

    resetTrigger (user) {
      this.$nextTick(() => {
        let count = 0
        let idx = this.selected.indexOf(user.id)

        let result = this.allUsers.find((row) => {
          return row.id === user.id
        })

        if (result.level_id !== user.level_id) {
          count += 1
        }

        if (result.vip_id !== user.vip_id) {
          count += 1
        }

        if (result.status !== user.status) {
          count += 1
        }

        if (count === 0 && idx > -1) {
          this.selected.splice(idx, 1)
        }
      })
    },

    openUser (id, subtype) {
      window.open(
        `${process.env.VUE_APP_URL}/user/${id}/${subtype}`,
        '',
        `width=${1400},height=${window.innerHeight}`
      )
    },

    getTransDetails (type, id) {
      window.open(
        `${process.env.VUE_APP_URL}/transfers/${type}/user/${id}`,
        '',
        `width=${1200},height=${window.innerHeight}`
      )
    },

    messageUser () {
      this.showMessageUser = true
      this.getAgentArchive()
      this.getCodeArchive()
      this.getAccountArchive()
    }
  }
}
</script>
